<template>
  <router-view/>
</template>
<script>
export default{
   name:'lendingRoot',
   mounted(){
     this.$myApi.singleRequest({
           "action":"loanForm",
            "typeRequest":"getRef"
      }).then((res)=>{
        this.$store.dispatch('saveRef', res)
      }).catch((res)=>{
        console.log(res)
      })
  }
}
</script>
<style>
  /*@font-face {*/
  /*  font-family: 'Roboto';*/
  /*  src: local('Roboto'),*/
  /*  local('Roboto-Regular'),*/
  /*  url('../public/font/Roboto.woff2') format('woff2'),*/
  /*  url('../public/font/Roboto.woff') format('woff'),*/
  /*  url('../public/font/Roboto.ttf') format('truetype');*/
  /*  font-weight: 400;*/
  /*  font-style: normal;*/
  /*}*/
  /*@font-face {*/
  /*  font-family: 'Roboto';*/
  /*  src: local('Roboto Bold'),*/
  /*  local('Roboto-Bold'),*/
  /*  url('../public/font/Robotobold.woff2') format('woff2'),*/
  /*  url('../public/font/Robotobold.woff') format('woff'),*/
  /*  url('../public/font/Robotobold.ttf') format('truetype');*/
  /*  font-weight: 700;*/
  /*  font-style: normal;*/
  /*}*/
  /*@font-face {*/
  /*  font-family: 'Roboto';*/
  /*  src: local('Roboto Medium'),*/
  /*  local('Roboto-Medium'),*/
  /*  url('../public/font/Robotomedium.woff2') format('woff2'),*/
  /*  url('../public/font/Robotomedium.woff') format('woff'),*/
  /*  url('../public/font/Robotomedium.ttf') format('truetype');*/
  /*  font-weight: 500;*/
  /*  font-style: normal;*/
  /*}*/
  /*@font-face {*/
  /*  font-family: "ALS";*/
  /*  src: url("../public/font/rouble.otf") format("opentype");*/
  /*}*/
  .rubl {font-family: "ALS";}
  @font-face {  font-display: swap }
  @font-face {  font-style: normal;  font-family: "Lato-Regular";  src: local("Lato-Regular"), url('../src/assets/fonts/lato-regular-webfont.woff') format("woff"), url('../src/assets/fonts/Lato-Regular.woff2') format("woff2"), url('../src/assets/fonts/Lato-Regular.ttf') format("truetype")}
  @font-face {  font-style: normal;  font-family: "Lato-Heavy";  src: local("Lato-Heavy"), url('../src/assets/fonts/lato-heavy-webfont.woff') format("woff"), url('../src/assets/fonts/Lato-Heavy.woff2') format("woff2"), url('../src/assets/fonts/Lato-Heavy.ttf') format("truetype")}
  @font-face {  font-style: normal;  font-family: "Lato-Bold";  src: local("Lato-Bold"), url('../src/assets/fonts/lato-bold-webfont.woff') format("woff"), url('../src/assets/fonts/Lato-Bold.woff2') format("woff2"), url('../src/assets/fonts/Lato-Bold.ttf') format("truetype")}
  /*@font-face {  font-style: normal;  font-family: "Lato-Black";  src: local("Lato-Black"), url('../src/assets/fonts/Lato-Black.woff') format("woff"), url('../src/assets/fonts/Lato-Black.woff2') format("woff2"), url('../src/assets/fonts/Lato-Black.ttf') format("truetype")}*/
  html {font-family: 'Lato-Regular';font-weight: 400;color:#222721}
  html, body, p,ul, li,input,button, h1, h2, h3{margin: 0;padding: 0;}
  li{list-style: none;}
  img, svg{border:0;display: inline-block;}
  button, input, select {font-family: 'Lato-Regular';color:#222721;border-radius: 1px;}
  .align {width: 90vw;margin: 0 auto;}
  .rapeAlign {position: relative;padding: 0 5vw;left: -5vw;width: 90vw;}

  button
  {width:100%;height: 16vw;font-weight: bold;border-radius: 3px;border: 0;text-transform: uppercase;cursor: pointer;transition:
    0.3s
    ease-out;background-color: #43AC35;color:white;font-size: 4.3vw;
    display: inline-flex;align-items: center;justify-content: center;
    margin: 0 auto;
  }
  button:hover {opacity: 0.8}
  button svg{display: none;width: 7.5vw;height: 7.5vw;}
  button span {display: inline-block;padding-left: 5vw;}
  button.svgMoney  svg:first-child{display: block}
  button.svgPoint  svg:last-child{display: block}

  h1 {font-size: 10vw;font-weight: 500;}

  section{padding: 14vw 0 4.7vw;}

  @media screen and (min-width: 760px) {
    /* calc in 1139width */
    .align{width: 98vw;}
    .rapeAlign{left: 0;width: 100%;padding: 0;}
    button {height: 5.8vw;font-size: 1.3vw;}
    button:hover {}
    button svg{width: 2.1vw;height: 2.1vw}
    button span {padding-left: 2vw;}
    button.svgMoney {}
    button.svgPoint {width: 30vw}

    h1 {font-size: 3.5vw}
    section {padding: 4vw 0 1.3vw;}

  }
  @media screen and (min-width: 1140px) {
    section {padding: 45px 0 25px;}
    .align{width: 1120px;}
    button {height: 63px;font-size: 14px;}
    button:hover {}
    button span {padding-left: 15px;}
    button svg{width: 24px;height: 24px}
    button.svgMoney {}
    button.svgPoint {width: 342px;}

    h1 {font-size: 40px}
  }



</style>
